// ========================================================================================================== SCROLLTOSCRIPT
function getSamePageAnchor (link) {
  if (
    link.protocol !== window.location.protocol ||
    link.host !== window.location.host ||
    link.pathname !== window.location.pathname ||
    link.search !== window.location.search
  ) {
    return false;
  }
  return link.hash;
}
function scrollToHash(hash, e) {
  const elem = hash ? document.querySelector(hash) : false;
  if(elem) {
    if(e) e.preventDefault();
    gsap.to(window, {scrollTo: elem, duration: 0.1});
  }
}
document.querySelectorAll('a[href]').forEach(a => {
  a.addEventListener('click', e => {
    scrollToHash(getSamePageAnchor(a), e);
  });
});
scrollToHash(window.location.hash);
// ========================================================================================================== FLICKITY NEXT PREV CLASSES
// ===================================================== 2 POSITIONS AWAY FROM ACTIVE CLASS
Flickity.createMethods.push('_createPrevNextCells');
Flickity.prototype._createPrevNextCells = function() {
  this.on( 'select', this.setPrevNextCells );
};
Flickity.prototype.setPrevNextCells = function() {
  // Remove classes from previously selected slides
  changeSlideClasses( this.previousSlide, 'remove', 'is-previous' );
  changeSlideClasses( this.nextSlide, 'remove', 'is-next' );
  changeSlideClasses( this.previousPreviousSlide, 'remove', 'is-previous-previous' );
  changeSlideClasses( this.nextNextSlide, 'remove', 'is-next-next' );
  // Calculate indices for previous, next, previous-previous, and next-next slides
  var previousI = fizzyUIUtils.modulo( this.selectedIndex - 1, this.slides.length );
  var nextI = fizzyUIUtils.modulo( this.selectedIndex + 1, this.slides.length );
  var previousPreviousI = fizzyUIUtils.modulo( this.selectedIndex - 2, this.slides.length );
  var nextNextI = fizzyUIUtils.modulo( this.selectedIndex + 2, this.slides.length );
  // Store references to these slides
  this.previousSlide = this.slides[ previousI ];
  this.nextSlide = this.slides[ nextI ];
  this.previousPreviousSlide = this.slides[ previousPreviousI ];
  this.nextNextSlide = this.slides[ nextNextI ];
  // Add classes to the new slides
  changeSlideClasses( this.previousSlide, 'add', 'is-previous' );
  changeSlideClasses( this.nextSlide, 'add', 'is-next' );
  changeSlideClasses( this.previousPreviousSlide, 'add', 'is-previous-previous' );
  changeSlideClasses( this.nextNextSlide, 'add', 'is-next-next' );
};
function changeSlideClasses( slide, method, className ) {
  if ( !slide ) {
    return;
  }
  slide.getCellElements().forEach( function( cellElem ) {
    cellElem.classList[ method ]( className );
  });
}
// ========================================================================================================== SECTION 3
// ===================================================== FLICKITY
new Flickity('.co-article-cooking-section-3-collection-slider', {
  cellAlign: "center",
  contain: true,
  prevNextButtons: true,
  pageDots: false,
  wrapAround: true,
  selectedAttraction: 0.005,
  friction: 0.15,
  on: {
    ready: function() {
      // SLIDER GSAP
      const coHomeSection3Items = [
        document.querySelector('.co-article-cooking-section-3-collection-slider .is-previous-previous .co-article-cooking-section-3-collection-item-frame-2'),
        document.querySelector('.co-article-cooking-section-3-collection-slider .is-previous .co-article-cooking-section-3-collection-item-frame-2'),
        document.querySelector('.co-article-cooking-section-3-collection-slider .is-selected .co-article-cooking-section-3-collection-item-frame-2'),
        document.querySelector('.co-article-cooking-section-3-collection-slider .is-next .co-article-cooking-section-3-collection-item-frame-2'),
        document.querySelector('.co-article-cooking-section-3-collection-slider .is-next-next .co-article-cooking-section-3-collection-item-frame-2')
      ].filter(item => item !== null);
    
      gsap.set('.co-article-cooking-section-3-main-title-frame', { opacity: 0, y: 30, transition: 0 });
      gsap.set('.co-article-cooking-section-3-thumbnail-items-wrapper', { opacity: 0, y: 30, transition: 0 });
      gsap.set('.co-article-cooking-section-3-main-button', { opacity: 0, y: 30, transition: 0 });
      gsap.set('.co-article-cooking-section-3-collection-tabs-wrapper', { opacity: 0, transition: 0 });
        
      let coHomeSection3Timeline = gsap.timeline({ paused: true });
      coHomeSection3Timeline.to(".co-article-cooking-section-3-collection-tabs-wrapper", {
        duration: 0.3,
        opacity: 1
      });
      coHomeSection3Timeline.to(".co-article-cooking-section-3-main-title-frame", {
        duration: 1,
        ease: "power2.inOut",
        y: 0,
        opacity: 1
      }, "-=0.3");
      coHomeSection3Timeline.to(".co-article-cooking-section-3-thumbnail-items-wrapper", {
        duration: 1,
        ease: "power2.inOut",
        y: 0,
        opacity: 1
      }, "-=0.9");
      coHomeSection3Timeline.fromTo(coHomeSection3Items, { opacity: 0, yPercent: 0, xPercent: 20 }, { opacity: 1, yPercent: 0, xPercent: 0, stagger: 0.1, duration: 1 }, "-=0.6");
      coHomeSection3Timeline.to(".co-article-cooking-section-3-main-button", {
        duration: 1,
        ease: "power2.inOut",
        y: 0,
        opacity: 1
      }, "-=0.9");
      
      ScrollTrigger.create({
        trigger: '.co-article-cooking-section-3-collection-tabs-wrapper', start:'top bottom', end: "bottom top",
        animation: coHomeSection3Timeline
      });
    }
  }
});